import type { FC } from "react";
import type { UUID } from "../../utils/uuid";
import { UploadFileType } from "./file-upload";
import { useCreateAssetCallback } from "./hooks/use-upsert-asset";
import type { Asset } from "./server/digital-asset-service";
import { UploadFileModal } from "./upload-file-modal";
import type { UiFolderId } from "./utils";

export const UploadNewFileModal: FC<{
  open: boolean;
  onOpen: () => void;
  onClose: () => void;
  onCancel: () => void;
  onChange: (folderId: UiFolderId | null) => void;
  onViewFileClick: (asset: Asset) => void;
  folderId: UUID | null;
  videoUploads: boolean;
  folders_feature_flag?: boolean;
}> = ({ videoUploads, ...props }) => {
  const createAsset = useCreateAssetCallback();
  const allowedFileTypes: (keyof typeof UploadFileType)[] = videoUploads
    ? ["image", "video", "pdf"]
    : ["image", "pdf"];

  return (
    <UploadFileModal
      heading="Upload file"
      onSave={createAsset}
      allowedFileTypes={allowedFileTypes}
      {...props}
    />
  );
};
